import { api } from '../config'

export const SUPPORT_URL = {
  getSupports: `${api.withAPI}/admin/support`,
  getSupport: `${api.withAPI}/admin/support`,
  deleteSupport: `${api.withAPI}/admin/support`,
  getReviews: `${api.withAPI}/admin/review`,
  getReview:`${api.withAPI}/admin/review`,
}
